export const GET_API_KEYS_QUERY_KEY = (organizationId: string) => [
  'api-keys',
  organizationId,
];

export const GET_API_KEY_SCOPES_QUERY_KEY = (organizationId: string) => [
  'api-keys',
  'scopes',
  organizationId,
];
